<template>
  <div>
    <a-modal
      v-model:open="open"
      :maskClosable="false"
      :keyboard="false"
      :closable="false"
      :title="$t('service.verify')"
      centered
      @ok="handleOk"
      :cancel-button-props="{ disabled: true }"
    >
      <a-form
        style="margin-top: 30px"
        :model="formState"
        name="basic"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        autocomplete="off"
      >
        <a-form-item
          :label="$t('service.account')"
          name="account"
          :rules="[{ required: true, message: t('service.accountin') }]"
        >
          <a-input v-model:value="formState.account" />
        </a-form-item>

        <a-form-item
          :label="$t('service.password')"
          name="password"
          :rules="[{ required: true, message: t('service.passwordin') }]"
        >
          <a-input-password
            autocomplete="on"
            v-model:value="formState.password"
            @keyup.enter="handleOk"
          />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
          :disabled="disabled"
          >{{ $t("service.submit") }}</a-button
        >
      </template>
    </a-modal>

    <div v-show="contentShow">
      <a-card :bordered="false" style="margin-bottom: 10px">
        <a-form
          ref="searchFormRef"
          name="advanced_search"
          class="ant-advanced-search-form"
          :model="searchFormState"
        >
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item name="searchKey" :label="$t('service.orderNumber')">
                <a-input
                  v-model:value="searchFormState.searchKey"
                  :placeholder="$t('service.orderin')"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="loadData()">
                {{ $t("service.search") }}
              </a-button>
              <a-button class="snowy-buttom-left" @click="reset">
                {{ $t("service.reset") }}
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </a-card>

      <!-- 直接从plm中查询 -->
      <!-- <a-card :bordered="false" v-if="route.query.lang == 'eng'">
        <a-table
          ref="table"
          :columns="columnsEn"
          :dataSource="dataSourceEn"
          bordered
          :tool-config="toolConfig"
        >
          <template #operator class="table-operator"> </template>
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'action'">
              <a @click="articleTest(record)">{{ $t("index.look") }}</a>
              <a-divider type="vertical" />
              <a @click="downloadPDF(record)">{{ $t("index.download") }}</a>
            </template>
          </template>
        </a-table>
      </a-card> -->
      <!-- 先从Bodor+查显示 -->
      <a-card :bordered="false" v-if="!plmFileShow">
        <a-table
          ref="table"
          :columns="columnsEn"
          :dataSource="dataSourceEn"
          bordered
          :tool-config="toolConfig"
        >
          <template #operator class="table-operator"> </template>
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'action'">
              <!-- 英文表格查看按钮 -->
              <a @click="article(record)">{{ $t("index.look") }}</a>
              <a-divider type="vertical" />
              <!-- 英文表格下载按钮 -->
              <a @click="download2(record)">{{ $t("index.download") }}</a>
            </template>
          </template>
        </a-table>
      </a-card>

      <!-- 再从plm查显示 -->
      <a-card :bordered="false" v-else>
        <a-table
          ref="table"
          :columns="columns"
          :dataSource="dataSourcePlm"
          bordered
          :row-key="(record) => record.id"
          :show-pagination="false"
          :tool-config="toolConfig"
          :loading="tbLoading"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'title'">
              <a-space>
                <FolderOpenOutlined
                  :style="{
                    fontSize: '20px',
                    color: 'rgba(24,144,255)',
                    marginRight: '5px',
                  }"
                />
              </a-space>
              <text>{{ record.title }}</text>
            </template>
            <template v-if="column.dataIndex === 'action'">
              <a-space>
                <a @click="openForm(record)">{{ $t("service.view") }}</a>
                <a-divider type="vertical" />
                <a @click="batchDownload(record)">{{ $t("service.download") }}</a>
              </a-space>
            </template>
          </template>
        </a-table>
      </a-card>
    </div>

    <a-drawer
      v-model:open="Fopen"
      :title="$t('service.deviceInfo')"
      :width="1000"
      :destroy-on-close="true"
      @close="onFormClose"
    >
      <a-card :bordered="false" :loading="fileLoading" :label="$t('service.randomFile')">
        <!-- plm随机文件 -->
        <a-table v-if="plmShow" :dataSource="plmList" :columns="listColumns">
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'action'">
              <a @click="lookplm(record)">{{ $t("service.view") }}</a>
              <a-divider type="vertical" />
              <a @click="download(record)">{{ $t("service.download") }}</a>
            </template>
          </template>
        </a-table>
      </a-card>
    </a-drawer>
    <!-- pdf -->
    <div class="zz_box" v-if="pdfSrc">
      <div class="zz_top"></div>
      <!-- <iframe width="100%" height="604px" :src="pdfSrc" v-if="pdfSrc" /> -->
      <div class="zz_close" @click="closeZz">关闭</div>
      <iframe :src="pdfSrc" width="100%" height="100%" frameborder="0"></iframe>
    </div>
    <!-- 加载中 -->
    <div class="zz_boxZ" v-if="loadShow">
      <div class="zz_boxModdle">
        <a-spin :tip="loadTitle"> </a-spin>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, reactive } from "vue";
import axios from "axios";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import JSZip from "jszip";
import { saveAs } from "file-saver";
const route = useRoute();
const i18n = useI18n();
const { t } = useI18n();
import { WalletOutlined, FolderOpenOutlined } from "@ant-design/icons-vue";

/**
 * 主函数入口
 */
init();

function init() {
  let loacl = localStorage.getItem("lang");
  if (route.query.lang == "en" && loacl != "en") {
    i18n.locale = "en";
    localStorage.setItem("lang", "en");
    location.reload();
  } else if (route.query.lang == "zh" && loacl != "zh") {
    i18n.locale = "zh";
    localStorage.setItem("lang", "zh");
    location.reload();
  }
}

/**控制弹窗打开与关闭 */
const open = ref(true);
/**控制弹窗提交按钮是否禁用 */
const disabled = computed(() => {
  return !(formState.value.account && formState.value.password);
});
/**控制弹窗按钮提交状态 */
const loading = ref(false);
/**弹窗表单数据 */
const formState = ref({
  account: "",
  password: "",
});
const contentShow = ref(false);
const bodorShow = ref(false); //bodor+随机文件显示
const plmShow = ref(false); //plm随机文件显示
const plmFileShow = ref(true); //plm随机文件目录显示
/**搜索条内容 */
let searchFormState = reactive({});
/**搜索条Dom */
const searchFormRef = ref();

/**表格DOM */
const table = ref(null);
/**表格加载状态 */
const tbLoading = ref(false);
/**表格展示数据 */
const dataSourcePlm = ref([]);
const dataSource = ref([
  { id: "a01", title: "01产品指南" },
  { id: "a02", title: "02系统操作说明书" },
  { id: "a03", title: "03现场就位作业指导书" },
  { id: "a04", title: "04操作系统安装程序" },
  { id: "a05", title: "05现场布置图" },
  { id: "a06", title: "06地基图" },
  { id: "a07", title: "07吊装示意图" },
  { id: "a08", title: "08电气原理图" },
  { id: "a09", title: "09切割气路原理图" },
  { id: "a10", title: "10水路原理图" },
  { id: "a11", title: "11气路原理图" },
  { id: "a12", title: "12润滑原理图" },
  { id: "a13", title: "13液压原理图" },
  { id: "a14", title: "14制冷原理图" },
  { id: "a15", title: "15产品一页纸" },
  { id: "a16", title: "16调试作业指导书" },
  { id: "a17", title: "17维修手册" },
  { id: "a20", title: "20自动化产品指南" },
  { id: "a21", title: "21现场就位作业指导书" },
  { id: "a22", title: "22自动化吊装示意图" },
  { id: "a23", title: "23自动化电气原理图" },
  { id: "a24", title: "24自动化气路原理图" },
  { id: "a25", title: "25润滑原理图" },
  { id: "a26", title: "26液压原理图" },
  { id: "其他", title: "其他" },
]);
const toolConfig = { refresh: true, height: true, columnSetting: false, striped: false };
/**表头数据 */
const columns = [
  {
    title: t("index.knowledgetb1"),
    dataIndex: "title",
  },
  {
    title: t("index.knowledgetb5"),
    dataIndex: "action",
    align: "center",
  },
  // {
  //   title: t("service.orderNumber"),
  //   dataIndex: "OrderNumber",
  // },
  // {
  //   title: t("service.deviceName"),
  //   dataIndex: "Name",
  // },
  // {
  //   title: t("service.deviceSeries"),
  //   dataIndex: "SeriesName",
  // },
  // {
  //   title: t("service.deviceModel"),
  //   dataIndex: "FModelName",
  // },
  // {
  //   title: t("service.language"),
  //   dataIndex: "FVersionName",
  // },
  // {
  //   title: t("service.version"),
  //   dataIndex: "FXVersionName",
  // },
  // {
  //   title: t("service.operation"),
  //   dataIndex: "action",
  //   align: "center",
  //   width: "100px",
  // },
];
/**分页 */
// const pagination = ref({
//   total: 0,
//   current: 1,
//   pageSize: 10,
//   showQuickJumper: true,
// });

const dataSourceEn = ref([]);
const columnsEn = [
  {
    title: t("index.knowledgetb1"),
    dataIndex: "title",
  },
  {
    title: t("index.knowledgetb5"),
    dataIndex: "action",
    align: "center",
  },
];

/**Form的DOM */
const Fopen = ref(false);
/**Form展示的数据 */
const machineData = ref({});
/**From随机文件列表 */
const uploadedList = ref([]);
// plm随机文件列表
const plmList = ref([]);
//pdf
const pdfSrc = ref();
const httpUrl = ref("https://cloud.bodor.com");
// 加载显示
const loadShow = ref(false);
const loadTitle = ref("loading..."); //加载内容
const listColumns = [
  {
    title: t("service.fileName"),
    dataIndex: "title",
  },
  // {
  //   title: t("service.machineType"),
  //   dataIndex: "machinetype",
  // },
  // {
  //   title: t("service.fileType"),
  //   dataIndex: "fileclassify",
  // },
  {
    title: t("service.operation"),
    dataIndex: "action",
  },
];
const infoLoading = ref(false);
const fileLoading = ref(false);

/**存储用户信息 */
const user = ref({});

/**弹窗点击确定 */
async function handleOk() {
  console.log("流程1点击确定按钮");
  /**等待登录结果 */
  await userLogin()
    .then((userData) => {
      open.value = false;
      message.success(t("service.success"));
      user.value = userData;
      localStorage.setItem("token", user.value.Token);
      contentShow.value = true;
      loadData();
    })
    .catch((error) => {
      message.error(error);
    });
}

/**验证登录 */
function userLogin() {
  loading.value = true;
  return new Promise((resolve, reject) => {
    let param = {
      Account: formState.value.account,
      Email: isMail(formState.value.account) ? formState.value.account : "",
      Password: formState.value.password,
    };
    if (route.query.lang != "eng") {
      param.IsAgent = "0";
    }
    axios
      .post("api/Login/UserLogin", param)
      .then(function (response) {
        loading.value = false;
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          console.log("流程1.1：", route.query.lang);
          debugger;
          let user = response.data.ReturnData;
          console.log("流程1.2：", user);
          debugger;
          if (user.IsBodorUser == "1" && route.query.lang != "en") {
            resolve(response.data.ReturnData);
            // } else if (route.query.lang == "en" && user.IsAgent == "0") {
          } else if (route.query.lang == "en") {
            resolve(response.data.ReturnData);
          } else {
            reject(t("service.error"));
          }
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

//判断邮箱
function isMail(mail) {
  return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(mail);
}

/**搜索数据 */
function loadData() {
  console.log("流程2=搜索数据", searchFormState.searchKey);
  // tbLoading.value = true;
  let newStr = searchFormState.searchKey || "";
  if (searchFormState.searchKey) {
    console.log("流程3：", searchFormState.searchKey);
    newStr = searchFormState.searchKey.replace(/\s+/g, "");
    console.log("流程4：", newStr);
    // pagination.value.current = 1;
  }
  // if (route.query.lang != "eng") {
  //   //先从bodor+中查询，再从plm中查询
  //   //英文接口
  //   let params = {
  //     OrderNumber: newStr,
  //   };
  //   console.log("英文表格传参params", params);
  //   axios
  //     .post("api/Machine/GetEquipmetFileData", params)
  //     .then((response) => {
  //       console.log("bodor+随机文件：", response.data);
  //       if (response.data.code == 200 && response.data.ReturnType == true) {
  //         if (
  //           response.data.ReturnData != null &&
  //           response.data.ReturnData.length > 0 &&
  //           response.data.ReturnData != "暂无数据"
  //         ) {
  //           dataSourceEn.value = response.data.ReturnData;
  //         } else {
  //           dataSourceEn.value = [];
  //           EnPlmFile(params);
  //         }
  //       } else {
  //         message.error(response.data.info);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     })
  //     .finally(() => {
  //       tbLoading.value = false;
  //     });
  // } else if (route.query.lang == "eng") {

  //直接从plm中查询
  //英文测试接口
  console.log("搜索单号：", newStr);
  dataSourcePlm.value = [];
  if (newStr != undefined && newStr != "") {
    let params = {
      OrderNumber: newStr,
    };
    EnPlmFile(params);
  } else {
    tbLoading.value = false;
  }

  //   } else {
  //     //查询设备
  //     //中文接口
  //     axios
  //       .post(
  //         "api/Machine/GetMachineTables",
  //         {
  //           OrderNumber: newStr,
  //           // PrevPageNums: (pagination.value.current - 1) * pagination.value.pageSize,
  //           // TopNums: pagination.value.pageSize,
  //         },
  //         {
  //           headers: {
  //             Token: user.value.Token,
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         console.log("设备列表：", response.data);
  //         let res = response.data.ReturnData;
  //         if (localStorage.getItem("lang") == "en") {
  //           res.forEach((data) => {
  //             data.FVersionName = replaceStr(data.FVersionName);
  //             data.SeriesName = replaceStr(data.SeriesName);
  //           });
  //         }
  //         dataSource.value = res;

  //         // pagination.value.total = response.data.ReturnCount;
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       })
  //       .finally(() => {
  //         tbLoading.value = false;
  //       });
  //   }
}

//英文plm随机文件搜索
function EnPlmFile(params) {
  console.log("英文plm随机文件搜索params", params);
  loadShow.value = true;
  loadTitle.value = "loading...";
  axios
    .post("api/RandomCenter/GetPLMRandomFile", params, {
      headers: {
        Token: user.value.Token,
      },
    })
    .then((response) => {
      console.log("plm随机文件：", response.data);
      loadShow.value = false; //加载隐藏
      if (response.data.code == 200) {
        if (response.data.ReturnData != null && response.data.ReturnData.length > 0) {
          tbLoading.value = false;
          plmFileShow.value = true;
          dataSourcePlm.value = dataSource.value;
        } else {
          tbLoading.value = false;
          plmFileShow.value = true;
          dataSourcePlm.value = dataSource.value;
        }
      } else {
        tbLoading.value = false;
        dataSourcePlm.value = [];
        message.error(response.data.info);
      }
    });
}

function replaceStr(str) {
  let result = str
    .replace(/系列/g, "-Series")
    .replace(/中文/g, "Chinese")
    .replace(/英文/g, "English");
  return result;
}

/**重置搜索 */
const reset = () => {
  searchFormRef.value.resetFields();
  loadData();
};

// 点击批量下载
const batchDownload = async (record) => {
  let params = {
    OrderNumber: searchFormState.searchKey,
    FileType: record.id,
  };
  console.log("点击批量下载：", params);
  //加载中
  fileLoading.value = true;

  if (record.id == "其他") {
    console.log("点击其他下载");
    let fileListAll = new Array();
    //加载plm文件
    const plmFileList = await getPlmFileCata(params).catch((error) => {
      fileLoading.value = false;
    });
    if (plmFileList && plmFileList.length > 0) {
      fileListAll = fileListAll.concat(plmFileList);
    }

    //加载bodor+文件
    let paramsB = {
      OrderNumber: searchFormState.searchKey,
    };
    const bodorFileList = await getBodorFileCata(paramsB).catch((error) => {
      fileLoading.value = false;
    });
    if (bodorFileList && bodorFileList.length > 0) {
      fileListAll = fileListAll.concat(bodorFileList);
    }

    console.log("下载其他总列表：", fileListAll);
    if (!fileListAll?.length) {
      message.warning("没有可下载的文件");
      return;
    }
    //取消加载
    fileLoading.value = false;
    const list = fileListAll.map((item) => ({
      ...item,
      FilePath: item.filepath,
      ext: (item.filename || item.title || "").split(".").pop().toLowerCase(),
    }));

    // 逐个下载
    for (let i = 0; i < list.length; i++) {
      const file = list[i];

      // CAD 格式特殊处理：使用 XHR 获取并强制下载
      if (["dxf", "dwg"].includes(file.ext)) {
        await download(file);
      } else {
        // 普通格式用 a 标签
        downloadNormalFile(file);
      }
    }

    message.success(`已下载 ${list.length} 个文件`);
  } else {
    try {
      const fileList = await getPlmFileCata(params).catch((error) => {
        fileLoading.value = false;
      });
      if (!fileList?.length) {
        message.warning("没有可下载的文件");
        return;
      }
      //取消加载
      fileLoading.value = false;
      const list = fileList.map((item) => ({
        ...item,
        FilePath: item.filepath,
        ext: (item.filename || item.title || "").split(".").pop().toLowerCase(),
      }));

      // 逐个下载
      for (let i = 0; i < list.length; i++) {
        const file = list[i];

        // CAD 格式特殊处理：使用 XHR 获取并强制下载
        if (["dxf", "dwg"].includes(file.ext)) {
          await download(file);
        } else {
          // 普通格式用 a 标签
          downloadNormalFile(file);
        }
      }

      message.success(`已下载 ${list.length} 个文件`);
    } catch (error) {
      fileLoading.value = false;
      message.error(error.message || "下载失败");
    } finally {
      fileLoading.value = false;
    }
  }
};

// 普通文件下载（a标签）
const downloadNormalFile = (file) => {
  const isAreas = file.FilePath.split("/")[1] === "Areas";
  const url = isAreas
    ? `https://apicloud.bodor.com${file.FilePath}`
    : `https://apicloud.bodor.com/wwwroot${file.FilePath}`;

  const a = document.createElement("a");
  a.href = url;
  a.download = file.title;
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

/**点击查看按钮，打开弹窗 */
async function openForm(record) {
  console.log("打开弹窗：", record.id);
  plmShow.value = true;
  let params = {
    OrderNumber: searchFormState.searchKey,
    FileType: record.id,
  };
  console.log("打开Formss：", record, params);
  Fopen.value = true; //打开弹窗

  // machineData.value = record;
  //加载中
  fileLoading.value = true;
  if (record.id == "其他") {
    console.log("选择了其他，同步加载plm和bodor+");
    //加载plm文件
    const plmFileList = await getPlmFileCata(params).catch((error) => {
      fileLoading.value = false;
    });
    console.log("plmFileList:", plmFileList);
    let fileListAll = new Array();
    let newFileList = new Array();
    if (plmFileList && plmFileList.length > 0) {
      for (var i = 0; i < plmFileList.length; i++) {
        let newObj = {
          fileclassify: "",
          machinetype: "",
          title: plmFileList[i].filename || "",
          FilePath: plmFileList[i].filepath,
        };
        newFileList.push(newObj);
      }
      fileListAll = fileListAll.concat(newFileList);
    }

    //加载bodor+文件
    let paramsB = {
      OrderNumber: searchFormState.searchKey,
    };
    const bodorFileList = await getBodorFileCata(paramsB).catch((error) => {
      fileLoading.value = false;
    });
    console.log("bodorFileList:", bodorFileList);
    //取消加载
    fileLoading.value = false;
    let newBodorFileList = new Array();
    if (bodorFileList && bodorFileList.length > 0) {
      for (var i = 0; i < bodorFileList.length; i++) {
        let newObjB = {
          fileclassify: "",
          machinetype: "",
          title: bodorFileList[i].title || "",
          FilePath: bodorFileList[i].filepath,
        };
        newBodorFileList.push(newObjB);
      }
      fileListAll = fileListAll.concat(newBodorFileList);
    }

    console.log("3，其他总file:", fileListAll);
    plmList.value = fileListAll;
    loadShow.value = false; //加载隐藏
    fileListAll.map((data, index) => {
      plmList.value[index].machinetype =
        plmList.value[index].machinetype == "0"
          ? t("service.cuttingMachine")
          : plmList.value[index].machinetype == "1"
          ? t("service.weldingMachine")
          : null;
      plmList.value[index].url = "https://apicloud.bodor.com" + data.FilePath;
    });
    console.log("获取成功流程3445：", plmList.value);
  } else {
    console.log("未选择其他，加载plm");
    await getPlmFileCata(params)
      .then((fileList) => {
        //取消加载
        fileLoading.value = false;
        console.log("获取成功：", fileList);
        let newFileList = new Array();
        for (var i = 0; i < fileList.length; i++) {
          let newObj = {
            fileclassify: "",
            machinetype: "",
            title: fileList[i].filename || "",
            FilePath: fileList[i].filepath,
          };
          newFileList.push(newObj);
        }
        console.log("获取成功流程2：", newFileList);
        plmList.value = newFileList;
        loadShow.value = false; //加载隐藏
        newFileList.map((data, index) => {
          plmList.value[index].machinetype =
            plmList.value[index].machinetype == "0"
              ? t("service.cuttingMachine")
              : plmList.value[index].machinetype == "1"
              ? t("service.weldingMachine")
              : null;
          plmList.value[index].url = "https://apicloud.bodor.com" + data.filepath;
        });
        console.log("获取成功流程3：", plmList.value);
      })
      .catch((error) => {
        //取消加载
        fileLoading.value = false;
        message.error(error);
      });
  }

  infoLoading.value = false;
}

/**关闭Form */
function onFormClose() {
  machineData.value = {};
}

//从plm中查询，带目录
const getPlmFileCata = (params) => {
  return new Promise((resolve, reject) => {
    axios
      .post("api/RandomCenter/GetPLMRandomFile", params, {
        headers: {
          Token: user.value.Token,
        },
      })
      .then((response) => {
        plmList.value = []; //清空原plm文件
        console.log("plm目录随机文件：", response.data);
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          if (response.data.ReturnData != null && response.data.ReturnData.length > 0) {
            resolve(response.data.ReturnData);
          } else {
            reject(t("service.noData"));
          }
        }
      });
  });
};
//从Bodor+中查询
const getBodorFileCata = (params) => {
  return new Promise((resolve, reject) => {
    axios.post("api/Machine/GetEquipmetFileData", params).then((response) => {
      if (response.data.code != 200) {
        reject(response.data.info);
      } else {
        if (response.data.ReturnData != null && response.data.ReturnData.length > 0) {
          resolve(response.data.ReturnData);
        } else {
          reject(t("service.noData"));
        }
      }
    });
  });
};

/**获取设备随机文件方法 */
// function getFile(id, code) {
//   //设备id，设备号
//   return new Promise((resolve, reject) => {
//     axios
//       .post(
//         "api/Machine/GetEquipmetFileData",
//         {
//           EquipmentId: id,
//         },
//         {
//           headers: {
//             Token: user.value.Token,
//           },
//         }
//       )
//       .then((response) => {
//         console.log("设备列表bodor+随机文件：", response.data);
//         if (response.data.code != 200) {
//           if (response.data.info != "暂无数据") {
//             reject(response.data.info);
//           }
//         } else {
//           if (response.data.ReturnData == null || response.data.ReturnData.length == 0) {
//             console.log("bodor+随机文件为空,从plm中搜索");
//             // reject(t("service.noData"));
//             //bodor+搜不到，从plm搜索
//             plmPdfList(code)
//               .then((fileList) => {
//                 let newFileList = new Array();
//                 for (var i = 0; i < fileList.length; i++) {
//                   let newObj = {
//                     fileclassify: "",
//                     machinetype: "",
//                     title: fileList[i].FileName || "",
//                     FilePath: fileList[i].FilePath,
//                   };
//                   newFileList.push(newObj);
//                 }
//                 plmList.value = newFileList;
//                 loadShow.value = false; //加载隐藏
//                 newFileList.map((data, index) => {
//                   plmList.value[index].machinetype =
//                     plmList.value[index].machinetype == "0"
//                       ? t("service.cuttingMachine")
//                       : plmList.value[index].machinetype == "1"
//                       ? t("service.weldingMachine")
//                       : null;
//                   plmList.value[index].url = "https://apicloud.bodor.com" + data.filepath;
//                 });
//               })
//               .catch((error) => {
//                 message.error(error);
//               });
//             fileLoading.value = false;
//             bodorShow.value = false; //bodor+随机按文件隐藏
//             plmShow.value = true; //plm随机文件显示
//             loadShow.value = true; //加载显示
//             loadTitle.value = "loading...";
//           } else {
//             resolve(response.data.ReturnData);
//           }
//         }
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
/**从plm搜索 */
// function plmPdfList(e) {
//   return new Promise((resolve, reject) => {
//     axios
//       .post(
//         "api/RandomCenter/GetPLMRandomFile",
//         {
//           OrderNumber: e,
//         },
//         {
//           headers: {
//             Token: user.value.Token,
//           },
//         }
//       )
//       .then((response) => {
//         console.log("设备列表plm搜索", response.data);
//         loadShow.value = false; //加载隐藏
//         if (response.data.code != 200) {
//           if (response.data.info != "暂无数据") {
//             reject(response.data.info);
//           }
//         } else {
//           if (!response.data.ReturnData) {
//             reject(t("service.noData"));
//           } else {
//             resolve(response.data.ReturnData);
//           }
//         }
//       });
//   });
// }
/**查看随机文件 */
// function look(record) {
//   let link = document.createElement("a");
//   //创建一个a标签
//   link.style.display = "none";
//   //将a标签隐藏
//   link.href = "https://apicloud.bodor.com" + record.filepath;
//   //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
//   link.setAttribute("download", record.title);
//   link.setAttribute("target", "_blank");
//   // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
//   document.body.appendChild(link);
//   //将上面创建的a标签加入到body的尾部
//   link.click();
// }
//关闭遮罩
function closeZz() {
  pdfSrc.value = "";
}
// 查看plm随机文件
function lookplm(record) {
  let url = httpUrl.value + record.FilePath;
  let name = record.title;
  // 发送http请求，将文件链接转换成文件流
  let xhr = new XMLHttpRequest();
  xhr.open("get", url, true);
  xhr.setRequestHeader("Content-Disposition", "attachment");
  xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
  // 请求类型
  xhr.responseType = "blob";
  xhr.onreadystatechange = function () {
    // 获取接口结果
    if (xhr.readyState === 4 && xhr.status === 200) {
      window.URL = window.URL || window.webkitURL;
      let a = document.createElement("a");
      let blob = new Blob([xhr.response]);
      // 通过二进制文件创建url
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      // 销毁创建的url
      window.URL.revokeObjectURL(url);
    } else {
      let link = document.createElement("a");
      //创建一个a标签
      link.style.display = "none";
      //将a标签隐藏
      link.href = "https://apicloud.bodor.com" + record.FilePath;
      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
      link.setAttribute("download", record.title);
      link.setAttribute("target", "_blank");
      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      //将上面创建的a标签加入到body的尾部
      link.click();
    }
  };
  xhr.send();
}

/**下载随机文件 */
function download(record) {
  message.info("已开始下载，请耐心等待");
  let url = "https://apicloud.bodor.com" + record.FilePath;
  let name = record.title;
  // 发送http请求，将文件链接转换成文件流
  let xhr = new XMLHttpRequest();
  xhr.open("get", url, true);
  xhr.setRequestHeader("Content-Disposition", "attachment");
  xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
  // 请求类型
  xhr.responseType = "blob";
  xhr.onreadystatechange = function () {
    // 获取接口结果
    if (xhr.readyState === 4 && xhr.status === 200) {
      window.URL = window.URL || window.webkitURL;
      let a = document.createElement("a");
      let blob = new Blob([xhr.response]);
      // 通过二进制文件创建url
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      // 销毁创建的url
      window.URL.revokeObjectURL(url);
    } else {
      let link = document.createElement("a");
      //创建一个a标签
      link.style.display = "none";
      //将a标签隐藏
      if (record.FilePath.split("/")[1] == "Areas") {
        link.href = "https://apicloud.bodor.com" + record.FilePath;
      } else {
        link.href = "https://apicloud.bodor.com/wwwroot" + record.FilePath;
      }

      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
      link.setAttribute("download", record.title);
      link.setAttribute("target", "_blank");
      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      //将上面创建的a标签加入到body的尾部
      link.click();
    }
  };
  xhr.send();
}

/**分页方法 */
// function handleTableChange(e) {
//   pagination.value = e;
//   loadData();
// }

const article = (record) => {
  console.log("点击英文查看按钮：", record);
  window.open(record.webpath + record.filepath);
};
//英文测试查看按钮
// const articleTest = (record) => {
//   let url = httpUrl.value + record.look.FilePath;
//   let name = record.title;
//   // 发送http请求，将文件链接转换成文件流
//   let xhr = new XMLHttpRequest();
//   xhr.open("get", url, true);
//   xhr.setRequestHeader("Content-Disposition", "attachment");
//   xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
//   // 请求类型
//   xhr.responseType = "blob";
//   xhr.onreadystatechange = function () {
//     // 获取接口结果
//     if (xhr.readyState === 4 && xhr.status === 200) {
//       window.URL = window.URL || window.webkitURL;
//       let a = document.createElement("a");
//       let blob = new Blob([xhr.response]);
//       // 通过二进制文件创建url
//       let url = window.URL.createObjectURL(blob);
//       a.href = url;
//       a.download = name;
//       a.click();
//       // 销毁创建的url
//       window.URL.revokeObjectURL(url);
//     } else {
//       let link = document.createElement("a");
//       //创建一个a标签
//       link.style.display = "none";
//       //将a标签隐藏
//       link.href = httpUrl.value + record.look.FilePath;
//       //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
//       link.setAttribute("download", record.title);
//       link.setAttribute("target", "_blank");
//       // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
//       document.body.appendChild(link);
//       //将上面创建的a标签加入到body的尾部
//       link.click();
//     }
//   };
//   xhr.send();
// };
//英文測試下載按鈕
// const downloadPDF = (record) => {
//   let url = httpUrl.value + record.look.FilePath;
//   let name = record.title;
//   // 发送http请求，将文件链接转换成文件流
//   let xhr = new XMLHttpRequest();
//   xhr.open("get", url, true);
//   xhr.setRequestHeader("Content-Disposition", "attachment");
//   xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
//   // 请求类型
//   xhr.responseType = "blob";
//   xhr.onreadystatechange = function () {
//     // 获取接口结果
//     if (xhr.readyState === 4 && xhr.status === 200) {
//       window.URL = window.URL || window.webkitURL;
//       let a = document.createElement("a");
//       let blob = new Blob([xhr.response]);
//       // 通过二进制文件创建url
//       let url = window.URL.createObjectURL(blob);
//       a.href = url;
//       a.download = name;
//       a.click();
//       // 销毁创建的url
//       window.URL.revokeObjectURL(url);
//     } else {
//       let link = document.createElement("a");
//       //创建一个a标签
//       link.style.display = "none";
//       //将a标签隐藏
//       link.href = httpUrl.value + record.look.FilePath;
//       //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
//       link.setAttribute("download", record.title);
//       link.setAttribute("target", "_blank");
//       // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
//       document.body.appendChild(link);
//       //将上面创建的a标签加入到body的尾部
//       link.click();
//     }
//   };
//   xhr.send();
// };

const download2 = (record) => {
  console.log("record:", record);
  // let url = httpUrl.value + record.look.FilePath;record.webpath +
  let url = "https://apicloud.bodor.com" + record.filepath;
  console.log("下载url:", url);
  let name = record.title;
  // 发送http请求，将文件链接转换成文件流
  let xhr = new XMLHttpRequest();
  xhr.open("get", url, true);
  // 请求类型
  xhr.responseType = "blob";
  xhr.onreadystatechange = function () {
    console.log("接口结果：", xhr.readyState, xhr.status);
    // 获取接口结果
    if (xhr.readyState === 4 && xhr.status === 200) {
      console.log("请求成功==");
      window.URL = window.URL || window.webkitURL;
      let a = document.createElement("a");
      let blob = new Blob([xhr.response]);
      // 通过二进制文件创建url
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      // 销毁创建的url
      window.URL.revokeObjectURL(url);
    } else {
      console.log("流程4");
      let link = document.createElement("a");
      //创建一个a标签
      link.style.display = "none";
      //将a标签隐藏
      console.log("流程4.14", record.filepath.split("/"));
      if (record.filepath.split("/")[1] == "Areas") {
        link.href = "https://apicloud.bodor.com" + record.filepath;
        console.log("有Areas: https://apicloud.bodor.com" + record.filepath);
      } else {
        link.href = "https://apicloud.bodor.com/wwwroot" + record.filepath;
        console.log("无Areas: https://apicloud.bodor.com/wwwroot" + record.filepath);
      }
      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
      console.log("reocrd.title:", record.title);
      link.setAttribute("download", record.title);
      console.log("此时link", link.href, link.download);
      link.setAttribute("target", "_blank");
      console.log("111111");
      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      console.log("222222");
      //将上面创建的a标签加入到body的尾部
      link.click();
      console.log("333333");
    }
  };
  xhr.send();
};
</script>

<style scoped>
a {
  color: #1890ff;
}

.cardImp {
  margin-right: 10px;
}

.ant-form-item {
  margin-bottom: 0 !important;
}

.primaryAdd {
  margin-right: 10px;
}

.snowy-buttom-left {
  margin-left: 8px;
}
.zz_box {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
}
.zz_boxZ {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.3);
}
.zz_boxModdle {
  margin-top: 400px;
  text-align: center;
}
.zz_top {
  width: 100%;
  height: 20px;
  background: #323639;
}
.zz_close {
  position: fixed;
  left: 10px;
  top: 10px;
  color: #1890ff;
  font-size: 16px;
  cursor: pointer;
}
</style>
